import { SOCIAL_MEDIA_TYPE_ENUM } from 'types/global';

const { FACEBOOK, LINKEDIN, PINTEREST, TUMBLR, TWITTER } = SOCIAL_MEDIA_TYPE_ENUM;

export const POPUP_SHARE_BUTTONS = [
  {
    isAllowedInForbiddenCounties: false,
    svgName: 'facebook-circle-brand',
    label: 'Facebook',
    smType: FACEBOOK,
  },
  {
    isAllowedInForbiddenCounties: true,
    svgName: 'pinterest-brand',
    label: 'Pinterest',
    smType: PINTEREST,
  },
  {
    isAllowedInForbiddenCounties: true,
    svgName: 'twitter-circle-brand',
    label: 'Twitter',
    smType: TWITTER,
  },
  {
    isAllowedInForbiddenCounties: true,
    svgName: 'linkedin-brand',
    label: 'Linkedin',
    smType: LINKEDIN,
  },
  { label: 'Tumblr', svgName: 'tumblr-brand', smType: TUMBLR, isAllowedInForbiddenCounties: true },
];
